// ============================================================================
// fordJavaslat.js — FORDÍTÁSJAVASLAT jóváhagyással, kliensoldali tiszta rész (2026-10-19, v107; a titkár #2/5. javaslata, a #33 pontosításaival).
// A szerver (functions/src/translationSuggestion.js) dönt és ír; ez a modul csak a megjelenítés / jogosultság-előszűrés adatai: ki mit lát, mi elavult.
// A szerver MINDIG újra ellenőriz (a kliens előszűrése nem védelem).
// ============================================================================

/** Az adott nyelv elfogadott emberi javítása (ki javasolta, ki fogadta el, mikor), vagy null. */
export function emberiJavitas(msg, nyelv) {
  const h = msg && msg.translationHuman && msg.translationHuman[nyelv] === true;
  const info = msg && msg.translationHumanInfo && msg.translationHumanInfo[nyelv];
  if (!h || !info || typeof info !== "object") return null;
  return {
    by: typeof info.by === "string" ? info.by : "", byName: typeof info.byName === "string" ? info.byName : "",
    decidedBy: typeof info.decidedBy === "string" ? info.decidedBy : "", decidedByName: typeof info.decidedByName === "string" ? info.decidedByName : "",
    at: typeof info.at === "number" ? info.at : 0, selfApproved: info.selfApproved === true,
    aiNote: typeof info.aiNote === "string" ? info.aiNote : "", note: typeof info.note === "string" ? info.note : "",
  };
}

/** Hány nyitott javaslat van az adott nyelvre (a hozzászólás `openSuggestions[nyelv]` listájának hossza). */
export function nyitottSzam(msg, nyelv) {
  const l = msg && msg.openSuggestions && typeof msg.openSuggestions === "object" ? msg.openSuggestions[nyelv] : null;
  return Array.isArray(l) ? l.length : 0;
}

/** A javaslat elavult-e: az eredeti szöveg vagy a mostani fordítás megváltozott a javaslat óta (ekkor az elfogadás sem érvényesülne). */
export function javaslatElavult(javaslat, msg, nyelv) {
  if (!javaslat || !msg) return true;
  const mostaniFordites = msg.translations && typeof msg.translations === "object" ? msg.translations[nyelv] : undefined;
  return javaslat.baseSrc !== (typeof msg.text === "string" ? msg.text : "") || javaslat.baseText !== mostaniFordites;
}

/** A fordítás-előzmény az adott nyelvre, legújabb elöl. */
export function elozmenyek(msg, nyelv) {
  const l = msg && Array.isArray(msg.translationEdits) ? msg.translationEdits : [];
  return l.filter((e) => e && typeof e === "object" && e.lang === nyelv && typeof e.text === "string").reverse();
}

/**
 * A javaslatot elbírálhatja-e a néző? (Előszűrés a gombokhoz; a szerver dönt.) A hozzászólás szerzője, a téma nyitója (es.tagKezelo forum-témánál),
 * admin / témafelelős; a javaslattevő a SAJÁT javaslatát nem (admin / témafelelős kivétel).
 */
export function eldonthet(javaslat, msg, myUid, es) {
  if (!javaslat || javaslat.status !== "open" || !myUid) return false;
  const staff = Boolean(es && es.isStaff === true);
  const szerzo = Boolean(msg && msg.senderId === myUid);
  const nyito = Boolean(es && es.tagKezelo === true);
  if (!staff && !szerzo && !nyito) return false;
  if (javaslat.by === myUid && !staff) return false;
  return true;
}

/** Visszavonhatja-e: a javaslattevő, vagy admin / témafelelős. */
export function visszavonhato(javaslat, myUid, es) {
  return Boolean(javaslat && javaslat.status === "open" && myUid && (javaslat.by === myUid || (es && es.isStaff === true)));
}

/** A Firestore-dokumentum a felületnek: csak a szabályos mezők, régebbi elöl. */
export function javaslatBol(id, x) {
  const s = (v) => (typeof v === "string" ? v : "");
  const n = (v) => (typeof v === "number" ? v : 0);
  return {
    id, lang: s(x.lang), proposedText: s(x.proposedText), baseText: s(x.baseText), baseSrc: s(x.baseSrc), reason: s(x.reason),
    by: s(x.by), byName: s(x.byName), at: n(x.at), status: ["open", "accepted", "rejected", "withdrawn", "expired"].includes(x.status) ? x.status : "open",
    aiNote: s(x.aiNote), decidedBy: s(x.decidedBy), decidedByName: s(x.decidedByName), decidedAt: n(x.decidedAt), decisionNote: s(x.decisionNote), selfDecided: x.selfDecided === true,
  };
}
